import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const queryCourierBankCard = async (params: object) => {
  return await GET({ url: Api.queryCourierBankCard, params, showError: false })
}
